import { render, staticRenderFns } from "./updHosm.vue?vue&type=template&id=0afe8932&scoped=true"
import script from "./updHosm.vue?vue&type=script&lang=js"
export * from "./updHosm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe8932",
  null
  
)

export default component.exports